import Item from './Item.js';

export default class MoveItem extends Item {
    constructor({ id, name, description, ppAmount, price }) {
        super({ id, name, description, price });
        this.ppAmount = ppAmount;
    }
}
